import clsx from 'clsx';
import { ReactNode } from 'react';

interface TabNavProps {
  active: Boolean;
  title: string;
  setCurrentTab?: React.Dispatch<React.SetStateAction<string>>;
  tabId: string;
  className?: string;
  handleClick?: () => void;
}

export const TabNav = ({
  title,
  active,
  setCurrentTab,
  handleClick,
  tabId,
  className,
}: TabNavProps) => {
  const setTabFunc = () => {
    setCurrentTab?.(tabId);
    handleClick?.();
  };
  return (
    <p
      className={clsx(
        'cursor-pointer rounded-md px-3 py-1 text-center text-lg hover:bg-zinc-100',
        active ? 'text-blue-500' : 'text-brand-dark',
        className
      )}
      onClick={setTabFunc}
    >
      {title}
    </p>
  );
};

interface TabContentProps {
  currentTab: string;
  tabId: string;
  children: ReactNode;
  className?: string;
}

export const TabContent = ({
  currentTab,
  tabId,
  children,
  className,
}: TabContentProps) => {
  if (currentTab !== tabId) {
    return null;
  }
  return <div className={className}>{currentTab === tabId && children}</div>;
};
